import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

export type Theme = 'primary' | 'secondary' | 'tertiary' | 'text' | 'warning';
type Type = 'button' | 'submit' | 'reset';
type Variant = '' | 'dark';
type Size = '' | 'sm';

@Component({
  selector: 'app-button',
  template: require('./button.component.html'),
  styles: [require('./button.component.scss')],
  encapsulation: ViewEncapsulation.None,
})

export class ButtonComponent implements OnInit {
  @Output() clicked: EventEmitter<void> = new EventEmitter();
  @Input() loading = false;
  @Input() type: Type = 'button';
  @Input() theme: Theme = 'primary';
  @Input() variant: Variant = '';
  @Input() size: Size = '';
  @Input() disabled = false;
  @Input() qa: string;
  @Input() icon: string;
  @Input() iconSize = 11;
  @Input() iconAsSuffix = false;
  @HostBinding('class') @Input() class = '';
  @HostBinding('class.stretch') @Input() stretch = false;


  ngOnInit() {
    this.class = `${this.class} ${this.theme} ${this.variant} ${this.size}`;
  }

  onClick(): void {
    if (!this.loading) {
      this.clicked.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/button/button.component.ts